import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-background-100">
          <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-4">页面未找到</h2>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-3 text-sm text-foreground-600">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-block px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}